import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { XCircle } from "lucide-react";
import { BRAND } from "@/lib/constants";

export default function BookingCancel() {
  return (
    <>
      <Header />
      <section className="min-h-screen pt-40 pb-24" data-testid="cancel-page">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <XCircle className="h-14 w-14 text-gold mx-auto mb-8" />
          <div className="overline mb-4">No charge made</div>
          <h1 className="font-serif-display text-5xl text-ivory leading-tight mb-6">Reservation paused.</h1>
          <p className="text-ivory-muted leading-relaxed mb-10">
            We held your details — pick up where you left off, or call us to confirm by phone.
          </p>
          <div className="flex gap-4 justify-center">
            <Link to="/book" className="btn-gold px-7 py-3" data-testid="cancel-retry">Resume Booking</Link>
            <a href={`tel:${BRAND.phone}`} className="btn-ghost-gold px-7 py-3" data-testid="cancel-call">Call {BRAND.phoneVanity}</a>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
